import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnnounceTooltipDirective } from './announce-tooltip.directive';

@NgModule({
	declarations: [AnnounceTooltipDirective],
	exports: [AnnounceTooltipDirective],
	imports: [CommonModule],
})
export class AnnounceTooltipModule {}